module.exports = __webpack_public_path__ + "static/media/6.6ad28b30.jpg";